export interface ITag {
  text: string;
  style?: string;
  classes?: string;
}

export enum TagClass {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

export interface ITagClasses {
  [tagValue: string]: TagClass;
}

export interface IAutocompleteItem {
  text: string;
}

export interface IStyledTagsInput {
  tags: ITag[];
  currentInput: string;
  filteredAutoCompleteItems: IAutocompleteItem[];
}
